import React from "react";
//#region types
import { VoucherProps } from "models/propTypes/voucherPropsTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
import TransactionsList from "./transactionList";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const Voucher: React.FC<VoucherProps> = (props) => {
  return (
    <>
      <Grid item container direction="column" className={cssExports.subSectionHeader}>
        <Grid item className={cssExports.subSectionTitle}>
          {`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Voucher)} ${
            props.voucherNumber
          } - ${props.voucherText}`}
        </Grid>
        <Grid item className={cssExports.subSectionSubTitle}>
          {LocalizationHelperInstance.getFormattedDate(props.bookingDate)}
        </Grid>
      </Grid>
      <TransactionsList {...props} />
    </>
  );
};

export default Voucher;
